module.exports = __webpack_public_path__ + "img/retrofit-5.0940062a.png";